// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1f9e228c] .el-scrollbar__wrap{margin-right:0!important}.employeeTree[data-v-1f9e228c]{position:relative;background:#fff;padding-top:10px}.employeeTree[data-v-1f9e228c] .basic-container .el-card{width:100%}.employeeTree[data-v-1f9e228c] .el-card__body{padding:10px 0!important}.avue-tree__content[data-v-1f9e228c]{height:viewPortHeight}", ""]);
// Exports
module.exports = exports;
